/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _ContinueInputs */

const en__continue = /** @type {(inputs: _ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continue`)
};

const es__continue = /** @type {(inputs: _ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continuar`)
};

const fr__continue = /** @type {(inputs: _ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continuer`)
};

const de__continue = /** @type {(inputs: _ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weiter`)
};

const ja__continue = /** @type {(inputs: _ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`続ける`)
};

const zh__continue = /** @type {(inputs: _ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`继续`)
};

const ar__continue = /** @type {(inputs: _ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`متابعة`)
};

const id__continue = /** @type {(inputs: _ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lanjutkan`)
};

const it__continue = /** @type {(inputs: _ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continua`)
};

const ru__continue = /** @type {(inputs: _ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Продолжить`)
};

const pt__continue = /** @type {(inputs: _ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continuar`)
};

const ko__continue = /** @type {(inputs: _ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`계속`)
};

/**
* | output |
* | --- |
* | "Continue" |
*
* @param {_ContinueInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
const _continue = /** @type {((inputs?: _ContinueInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_ContinueInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__continue(inputs)
	if (locale === "es") return es__continue(inputs)
	if (locale === "fr") return fr__continue(inputs)
	if (locale === "de") return de__continue(inputs)
	if (locale === "ja") return ja__continue(inputs)
	if (locale === "zh") return zh__continue(inputs)
	if (locale === "ar") return ar__continue(inputs)
	if (locale === "id") return id__continue(inputs)
	if (locale === "it") return it__continue(inputs)
	if (locale === "ru") return ru__continue(inputs)
	if (locale === "pt") return pt__continue(inputs)
	return ko__continue(inputs)
});
export { _continue as "continue" }